import {
  DocumentTypePropertyType,
} from '../../../../../../../services/common/Constants';
import React from 'react';
import DateFormValue from './date';
import CheckboxFormValue from './checkbox';
import DeviseFormValue from './devise';
import StandardFormValue from './standard';

const FormValue = ({
  fieldName,
  selectedFieldSubType,
  selectedComplexListSubFieldType,
  selectedOperator,
  availableValueOptions,
  showLabel,
  readOnly = false
}) => {
  switch (selectedFieldSubType) {
    case DocumentTypePropertyType.CHAINE:
    case DocumentTypePropertyType.MULTILIGNES:
    case DocumentTypePropertyType.EMAIL:
    case DocumentTypePropertyType.TELEPHONE:
    case DocumentTypePropertyType.IBAN:
    case DocumentTypePropertyType.RADIO_BUTTON:
    case DocumentTypePropertyType.LIST_ITEM:
    case DocumentTypePropertyType.BANK_COUNTRY_CODE:
      return (
        <StandardFormValue
          availableValueOptions={availableValueOptions}
          selectedOperator={selectedOperator}
          fieldName={fieldName}
          showLabel={showLabel}
          readOnly={readOnly}
        />
      );
    case DocumentTypePropertyType.MONTANT:
    case DocumentTypePropertyType.NOMBRE:
    case DocumentTypePropertyType.DEVISE:
    case DocumentTypePropertyType.DECIMAL:
      return (
        <DeviseFormValue
          fieldName={fieldName}
          selectedOperator={selectedOperator}
          showLabel={showLabel}
          availableValueOptions={availableValueOptions}
          readOnly={readOnly}
        />
      );

    case DocumentTypePropertyType.DATE:
      return (
        <DateFormValue
          fieldName={fieldName}
          selectedOperator={selectedOperator}
          showLabel={showLabel}
          readOnly={readOnly}
        />
      );

    case DocumentTypePropertyType.CASE_A_COCHER:
      return (
        <CheckboxFormValue
          fieldName={fieldName}
          selectedOperator={selectedOperator}
          showLabel={showLabel}
          availableValueOptions={availableValueOptions}
          readOnly={readOnly}
        />
      );

    case DocumentTypePropertyType.LISTE_CHOIX:
      switch (selectedComplexListSubFieldType) {
        case DocumentTypePropertyType.CHAINE:
        case DocumentTypePropertyType.MULTILIGNES:
        case DocumentTypePropertyType.EMAIL:
        case DocumentTypePropertyType.TELEPHONE:
        case DocumentTypePropertyType.IBAN:
        case DocumentTypePropertyType.RADIO_BUTTON:
        case DocumentTypePropertyType.LIST_ITEM:
        case DocumentTypePropertyType.BANK_COUNTRY_CODE:
          return (
            <StandardFormValue
              availableValueOptions={availableValueOptions}
              selectedOperator={selectedOperator}
              fieldName={fieldName}
              showLabel={showLabel}
            />
          );
        case DocumentTypePropertyType.MONTANT:
        case DocumentTypePropertyType.NOMBRE:
        case DocumentTypePropertyType.DEVISE:
        case DocumentTypePropertyType.DECIMAL:
          return (
            <DeviseFormValue
              fieldName={fieldName}
              selectedOperator={selectedOperator}
              showLabel={showLabel}
              availableValueOptions={availableValueOptions}
            />
          );

        case DocumentTypePropertyType.DATE:
          return (
            <DateFormValue
              fieldName={fieldName}
              selectedOperator={selectedOperator}
              showLabel={showLabel}
            />
          );

        case DocumentTypePropertyType.CASE_A_COCHER:
          return (
            <CheckboxFormValue
              fieldName={fieldName}
              selectedOperator={selectedOperator}
              showLabel={showLabel}
              availableValueOptions={availableValueOptions}
            />
          );

        default:
          break;
      }
      break;

    default:
      break;
  }
};

export default FormValue;
